module.exports = __webpack_public_path__ + "img/personPosition_checked.b3d5b97b.png";